import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import {
  selectConfigSell,
  selectPhotoGroups,
  selectPhotosList,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import { combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListOfPhotosToChooseFromInProductService {
  constructor(private store: Store) {}

  find(productId): Array<{ photoId: string }> {
    const photosSelectedByPhotographer: Array<{ photoId: string }> = [];
    combineLatest([
      this.store.pipe(select(selectPhotoGroups)),
      this.store.pipe(select(selectPhotosList)),
      this.store.pipe(select(selectConfigSell)),
    ])
      .pipe(first())
      .subscribe(([photoGroups, photosList, configSell]) => {
        photoGroups.forEach(({ config, photoGroupId }) => {
          const excludedProducts =
            config.individualSellSettings &&
            config.sellProducts &&
            config.customProductsConfig
              ? config.excludedProducts
              : config.individualSellSettings &&
                config.sellProducts &&
                configSell.sellProducts
              ? configSell.excludedProducts
              : !config.individualSellSettings && configSell.sellProducts
              ? configSell.excludedProducts
              : [productId];
          if (!excludedProducts?.includes(productId)) {
            photosSelectedByPhotographer.push(
              ...(photosList
                .find(({ photos }) =>
                  photos.find(({ photoGroupId: g }) => g === photoGroupId)
                )
                ?.photos.map(({ photoId }) => ({
                  photoId,
                })) || [])
            );
          }
        });
      });
    return photosSelectedByPhotographer;
  }
}
